export default __webpack_public_path__ + "4ffe52971add74b433552a2ea09fefff.svg";